import { css } from "emotion";
import { max } from "../../../utils/CssUtils";
import ColorServices from "../../../services/ColorServices";
import H2 from "../../../components/global/H2";
import Image from "../../../components/Image";
import Button from "../../../components/global/Button";
import config from "../../../config";
import P from "../../../components/global/P";

const consoleUrl = config("CONSOLE_URL");
const signupUrl = `${config("CONSOLE_URL")}/signup`;

const bannerImage = require("../../../assets/HostEvents/banner.png");

const bannerStyle = css({
  maxWidth: 400,
  h2: {
    fontSize: 32,
    color: ColorServices.getColor("white"),
    marginBottom: 16,
    letterSpacing: -1.1
  },
  p: {
    color: ColorServices.getColor("white"),
    marginBottom: 24
  },
  [max(1040)]: {
    paddingTop: 32,
    margin: "0 auto"
  },
  [max(768)]: {
    h2: {
      fontSize: 20
    }
  }
});

const headerImageWrapper = css({
  maxWidth: 528,
  maHeight: 370,
  marginRight: 102,
  [max(1040)]: {
    marginRight: 0,
    margin: "0 auto"
  }
});

const headerWrapper = css({
  backgroundColor: "#41157a"
});

const headerContentWrapper = css({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  maxWidth: 1200,
  margin: "0 auto",
  padding: "40px 0px",
  [max(1040)]: {
    display: "block",
    padding: "40px 14px"
  }
});

const FeaturesAndPricingBanner = () => {
  return (
    <div className={headerWrapper}>
      <div className={headerContentWrapper}>
        <div className={headerImageWrapper}>
          <Image imageURL={bannerImage} alt="Mock Event" />
        </div>
        <div className={bannerStyle}>
          <H2>Free for free tickets. Paid events have serious impact.</H2>
          <P>
            In as little as two minutes you can make your event live, delight
            your guests, and change lives through education projects.
          </P>
          <Button
            size="large"
            type="secondary"
            link={consoleUrl}
            ariaLabel="Get started"
            link={signupUrl}
          >
            Get started
          </Button>
        </div>
      </div>
    </div>
  );
};

export default FeaturesAndPricingBanner;
